// extracted by mini-css-extract-plugin
module.exports = {"container":"Top5Card_container__2224Q","column":"Top5Card_column__1MOS9","column1":"Top5Card_column1__1tMPk","toUser":"Top5Card_toUser__3yTsu"};